import { gql } from '@apollo/client/core';

const fragBullhorn = gql`fragment bullhorn on Bullhorn {
  id
  bullhorn
  favorite
}`;

export const findBullhorns = gql`
 ${fragBullhorn}
query($getfavourite: Boolean) {
  findBullhorns(getfavourite: $getfavourite) {
    ...bullhorn
    description
    category {
      id
      category
    }
  }
}`;

export const findBullhorn = gql`
 ${fragBullhorn}
query($id: Int!) {
  findBullhorn(id: $id) {
    ...bullhorn
    description
    category {
      id
      category
    }
    createdAt
    createdBy
  }
}`;

export const findEntityQuotes = gql`query($entityType: String!, $entityId: Int!) {
  findEntityQuotes(entityType: $entityType entityId: $entityId) {
    id
    author
    quote
  }
}`;

export const findChannels = gql`query($getfavourite: Boolean) {
  findChannels(getfavourite: $getfavourite) {
    id
    channel
    description
    favorite
    category {
      id
      category
    }
  }
}`;

export const findChannel = gql`query($id: Int!) {
  findChannel(id: $id) {
    id
    channel
    description
    favorite
    category {
      id
      category
    }
    createdAt
    createdBy
  }
}`;

export const findInterests = gql`query {
  findInterests {
    id
    interest
    favorite
    description
    category {
      id
      category
    }
  }
}`;

export const findInterest = gql`query($id: Int!) {
  findInterest(id: $id) {
    id
    interest
    description
    favorite
    category {
       id
       category
    }
    createdBy
    createdAt
  }
}`;

export const findValues = gql`query($getfavourite: Boolean) {
  findValues(getfavourite: $getfavourite) {
    id
    value
    description
    favorite
  }
}`;

export const findValue = gql`query($id: Int!) {
  findValue(id: $id) {
    id
    value
    description
    favorite
    createdBy
    createdAt
  }
}`;

export const mutateValue = gql`mutation ($input: ValueInput!) {
  mutateValue(input: $input) {
    id
    value
    description
    favorite
  }
}`;

export const dictionaryItems = gql` query{
  dictionaryItems {
    id
    term
    description
    source
    bullhorns {
      id
      bullhorn
   }
  }
}`;

export const dictionaryItem = gql` query($id: Int!){
  dictionaryItem(id: $id) {
    id
    term
    description
    source
    bullhorns {
      id
      bullhorn
   }
   createdBy
   createdAt
  }
}`;

export const mutateDictionaryItem = gql`mutation ($input: DictionaryInput!) {
  mutateDictionaryItem(input: $input) {
    id
    term
    description
    source
    bullhorns {
      id
      bullhorn
    }
    createdBy
    createdAt
  }
}`;

export const mutateBullhorn = gql`mutation ($input: BullhornInput!) {
  mutateBullhorn(input: $input) {
    id
    bullhorn
    description
  }
}`;

export const mutateChannel = gql`mutation ($input: ChannelInput!) {
  mutateChannel(input: $input) {
    id
    channel
    description
    favorite
  }
}`;

export const mutateEntityQuote = gql`mutation ($input: EntityQuoteInput!) {
  mutateEntityQuote(input: $input) {
    id
    author
    quote
  }
}`;

export const mutateInterest = gql`mutation ($input: InterestInput!) {
  mutateInterest(input: $input) {
    id
    interest
    description
    favorite
  }
}`;

export const mutateCategory = gql`mutation ($input: CategoryInput!) {
     mutateCategory(input: $input) {
        id
        categoryType
        category
     }
}`;

export const findCategories = gql`query ($type: String! ) {
    findCategories(type: $type) {
       id
       categoryType
       category
    }
}`;

export const findSegments = gql`query($entity: String!, $entityId : String!) {
  getSegments(entity: $entity entityId: $entityId) {
    id
    entity
    entityId
    segment
    cover
    description
    isActive
    createdAt
    updatedAt
  }
}`;

export const findSegment = gql`query($segmentId: String!) {
  getSegment(segmentId: $segmentId) {
    id
    entity
    entityId
    segment
    cover
    description
    isActive
    createdAt
    updatedAt
  }
}`;

export const mutateSegment = gql`mutation ($input: SegmentInput!) {
  addOrUpdateSegment(input: $input) {
    id
    entity
    entityId
    segment
    cover
    description
    isActive
    createdAt
    updatedAt
  }
}`;

export const findAllStaticPages = gql`query FindAllStaticPages {
  findAllStaticPages {
    id
    slug
    title
  }
}`;

export const findStaticPage = gql`query FindStaticPage($isId: Boolean!, $idOrSlug: String!) {
  findStaticPage(isId: $isId, idOrSlug: $idOrSlug) {
    id
    slug
    title
    greenGradientEnabled
    blocks {
      id
      sortOrder
      blockType
      isEnabled
    }
    bannerBlocks {
      id
      setFullWidth
      items {
        imageUrl
        deepLink
        isEnabled
      }
    }
    richTextBlocks {
      id
      heading
      text
    }
    searchBarBlocks {
      id
      searchType
      placeholderText
    }
    announcementBlocks {
      id
      text
      textColor
      textBackgroundColor
    }
    stickersBlocks {
      id
      title
      columnsCount
      stickersList
    }
    organizationsBlocks {
      id
      title
      organizationsList
    }
    listBlocks {
      id
      title
      organizationsList
    }
    collectionsBlocks {
      id
      title
      groups {
        title
        coverImageUrl
        isEnabled
        organizationsList
      }
    }
    questionBlocks {
      id
      text
      questionId
      organizationId
    }
    stickers {
      id
      title
      url
      thumbnailUrl
      organization {
        id
        name
      }
      user {
        id
        firstname
        lastname
      }
    }
    organizations {
      id
      name
      avatar
    }
  }
}`;

export const mutateRemoveStaticPageBlock = gql`
mutation MutateRemoveStaticPageBlock($blockId: String!, $id: String!) {
  mutateRemoveStaticPageBlock(blockId: $blockId, id: $id)
}`;

export const mutateToggleStatusStaticPageBlock = gql`
mutation MutateToggleStatusStaticPageBlock($id: String!, $blockId: String!) {
  mutateToggleStatusStaticPageBlock(id: $id, blockId: $blockId)
}`;

export const mutateStaticPage = gql`
mutation MutateStaticPage($input: StaticPageInput!) {
  mutateStaticPage(input: $input) {
    id
    slug
    title
    greenGradientEnabled
  }
}`;

export const mutateRemoveStaticPage = gql`mutation MutateRemoveStaticPage($id: String!) {
  mutateRemoveStaticPage(id: $id)
}`;

export const mutateRichTextBlock = gql`
mutation MutateRichTextBlock($input: RichTextBlockInput!) {
  mutateRichTextBlock(input: $input) {
    id
    heading
    text
  }
}`;

export const mutateSearchBarBlock = gql`
mutation MutateSearchBarBlock($input: SearchBarBlockInput!) {
  mutateSearchBarBlock(input: $input) {
    id
    searchType
    placeholderText
  }
}`;

export const mutateAnnouncementBlock = gql`
mutation MutateAnnouncementBlock($input: AnnouncementBlockInput!) {
  mutateAnnouncementBlock(input: $input) {
    id
    text
    textColor
    textBackgroundColor
  }
}`;

export const mutateStickersBlock = gql`
mutation MutateStickersBlock($input: StickersBlockInput!) {
  mutateStickersBlock(input: $input) {
    id
    title
    columnsCount
    stickersList
  }
}`;

export const mutateOrganizationsBlock = gql`
mutation MutateOrganizationsBlock($input: OrganizationsBlockInput!) {
  mutateOrganizationsBlock(input: $input) {
    id
    title
    organizationsList
  }
}`;

export const mutateListBlock = gql`
mutation MutateListBlock($input: ListBlockInput!) {
  mutateListBlock(input: $input) {
    id
    title
    organizationsList
  }
}`;

export const mutateFeaturedQuestion = gql`
mutation MutateFeaturedQuestion($orgId: String, $input: FeaturedQuestionInput!) {
  mutateFeaturedQuestion(orgId: $orgId, input: $input) {
    id
    content
    createdAt
  }
}`;

export const mutateQuestionBlock = gql`
mutation MutateQuestionBlock($input: QuestionBlockInput!) {
  mutateQuestionBlock(input: $input) {
    id
    text
    questionId
    organizationId
  }
}`;

export const mutateBannerBlock = gql`
mutation MutateBannerBlock($input: BannerBlockInput!) {
  mutateBannerBlock(input: $input) {
    id
    setFullWidth
    items {
      imageUrl
      deepLink
      isEnabled
    }
  }
}`;

export const mutateCollectionsBlock = gql`
mutation MutateCollectionsBlock($input: CollectionsBlockInput!) {
  mutateCollectionsBlock(input: $input) {
    id
    title
    groups {
      title
      coverImageUrl
      isEnabled
      organizationsList
    }
  }
}`;

export const findAllFeaturedQuestions = gql`
query FindAllFeaturedQuestions($orgId: String, $take: Int!, $skip: Int!) {
  findAllFeaturedQuestions(orgId: $orgId, take: $take, skip: $skip) {
    id
    content
    createdAt
  }
}`;

export const findAllFeaturedQuestionAnswers = gql`
query FindAllFeaturedQuestionAnswers($questionId: UUID!, $take: Int, $skip: Int) {
  findAllFeaturedQuestionAnswers(questionId: $questionId, take: $take, skip: $skip) {
    id
    content
    createdAt
  }
}`;
